import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';
import { triggerEdapEvent } from '../../utils/edap';
import { MODULE_VIEW_EVENT } from './events';

class EdapModuleView extends Component {
  constructor(props) {
    super(props);
    this.onWindowScroll = debounce(this.onWindowScroll, 300);
  }

  componentDidMount() {
    if (this.isComponentVisible()) {
      this.onComponentVisible();
    } else {
      window.addEventListener('scroll', this.onWindowScroll);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onWindowScroll);
  }

  onWindowScroll = () => {
    if (this.isComponentVisible()) {
      this.onComponentVisible();
      window.removeEventListener('scroll', this.onWindowScroll);
    }
  }

  onComponentVisible = () => {
    const { eventOptions, onModuleViewed } = this.props;
    triggerEdapEvent(MODULE_VIEW_EVENT, eventOptions);
    onModuleViewed();
  }

  isComponentVisible = () => {
    const { offsetHeight, offsetTop } = this.el;
    const { scrollY, innerHeight } = window;

    // We consider that the user has seen the component when it's fully visible
    return (scrollY + innerHeight) >= (offsetTop + offsetHeight);
  }

  setEl = (node) => {
    this.el = node;
  }

  render() {
    const { className, tagName } = this.props;
    const Tag = tagName;
    return (
      <Tag ref={this.setEl} className={className} >
        {this.props.children}
      </Tag>
    );
  }
}

EdapModuleView.defaultProps = {
  onModuleViewed: () => {},
  tagName: 'div',
  className: null
};

EdapModuleView.propTypes = {
  eventOptions: PropTypes.shape({
    actionlocation: PropTypes.string
  }).isRequired,
  onModuleViewed: PropTypes.func,
  tagName: PropTypes.string,
  className: PropTypes.string
};

export default EdapModuleView;



// WEBPACK FOOTER //
// ./src/universal/components/EdapModuleView/EdapModuleView.js